import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloud, faCloudSun, faSearch, faSnowflake, faSun, faCloudShowersHeavy } from '@fortawesome/free-solid-svg-icons';
import './Wetherapp.css';

const Weatherapp = () => {
  const [city, setCity] = useState('');
  const [weatherData, setWeatherData] = useState(null);

  const apiKeys = "19553afcd64eceaad88ce593845bd176";

  const fetchWeatherData = async () => {
    if (city.length <= 0) {
      return;
    }
    try {
      const response = await fetch(
        `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKeys}`
      );
      const data = await response.json();
      setWeatherData(data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    fetchWeatherData();
    setCity('')
  };

  let icon = null;

  switch (weatherData?.weather?.[0]?.main) {
    case 'Clouds':
      icon = faCloud;
      break;
    case 'Clear':
      icon = faSun;
      break;
    case 'Rain':
      icon = faCloudShowersHeavy;
      break;
    case 'Snow':
      icon = faSnowflake;
      break;
    default:
      icon = faCloudSun;
      break;
  }
  return (
    <>
      <div className="Card">
        <div className="Container">
          <h3 className='current-location'>
            {weatherData?.name}, {weatherData?.sys?.country}
          </h3>

          <div className='wrapper-date-cel'>
            <div className='wrapper'>
              <div className='Date'>
                <h3 className='time'>{new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</h3>
                <h3 className='day-month-year'>
                  {new Date().toLocaleDateString('en-US', {
                    weekday: 'long',
                    month: 'long',
                    day: 'numeric',
                    year: 'numeric'
                  })}
                </h3>
                {/* Additional date display logic can be added here */}
              </div>
              <h2 className='Celsuis'>
                {weatherData?.main?.temp ? `${weatherData.main.temp} ℃` : ''}
              </h2>
            </div>
          </div>
        </div>
        <div className="Container-right">
          <FontAwesomeIcon className='icon' icon={icon} />
          <h1 className='weather-title'>
            {weatherData?.weather?.[0]?.main}
          </h1>
          <hr />
          <div className='Search-bar'>
            <input
              type="text"
              className='input-search'
              placeholder="Enter Your City"
              value={city}
              onChange={(e) => setCity(e.target.value)}
            />
            <button className='Search-btn' onClick={handleSubmit}>
              <FontAwesomeIcon className='search-i' icon={faSearch} />
            </button>
          </div>

          <h2 className='city-name'>
            {weatherData?.name} , {weatherData?.sys?.country}
          </h2>

          <div className='weather-detail'>
            <h2 className='weather temp'>
              Temperature
              <span className='weather-number'>
                {weatherData?.main?.temp} ℃
              </span>
            </h2>
            <h2 className='weather humidity'>
              Humidity{' '}
              <span className='weather-number'>
                {weatherData?.main?.humidity}%
              </span>
            </h2>

            <h2 className='weather visibility'>
              Visibility{' '}
              <span className='weather-number'>
                {weatherData?.visibility} m
              </span>
            </h2>

            <h2 className='weather wind-speed'>
              Wind Speed{' '}
              <span className='weather-number'>
                {weatherData?.wind?.speed} km/h
              </span>
            </h2>
          </div>
        </div>
      </div>
    </>
  );
};

export default Weatherapp;
